'use client';
/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import EmbedIcons from '@app-ps/Components/Icon/EmbedIcons';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';

import { BiMicrophone } from 'react-icons/bi';
import { RiShareForwardLine } from 'react-icons/ri';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import config from '@config';
/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 */

const PsRelatedPost = ({ sectionContent, lang }) => {
  // State to toggle visibility of EmbedIcons
  const [showIcons, setShowIcons] = useState(false);

  // Function to toggle showIcons
  const handleIconClick = () => {
    setShowIcons(!showIcons);
  };

  const bgColor = `linear(${useBreakpointValue({
    base: 'to-t',
    md: '90deg',
  })}, rgba(2, 9, 18, 0) 0%, rgba(30, 90, 153, 0.4) 25%, rgba(2, 9, 18, 0) 100%)`;
  const textColor = '#FEFAF6';
  const isMobile = useBreakpointValue({ base: false, md: true });

  return (
    // <Box p={{ base: '0 1rem', md: '0 5rem 10rem' }}>
    <Box
      p={{ base: '0', md: '0 ', '2xl': '0 0 10rem' }}
      paddingTop={{ base: '20%', '2xl': '5%' }}
      paddingBottom={{ lg: '5%', '2xl': '4%' }}
    >
      <Box
        w="100%"
        mx="auto"
        px={{ base: '16px', lg: '3.5rem', xl: '0' }}
        maxW={{ base: 'none', lg: 1160, '2xl': 1470 }}
        my={{ md: '4rem', '2xl': '0' }}
        marginTop={{ base: '0rem', md: '4rem', lg: '8rem' }}
        mb={{ base: '2rem', md: '4rem', xl: '0' }}
        display="flex"
        alignItems="center"
        gap={{ lg: '48%', xl: '50%', '2xl': '0' }}
        justifyContent={{
          base: 'space-between',
          lg: 'space-between',
          '2xl': 'space-between',
        }}
      >
        <Text
          fontSize={{ base: '1.5rem', sm: '1.75rem', lg: '2.25rem' }}
          lineHeight="2.7rem"
          as="h3"
        >
          <Text
            as="span"
            fontWeight="400"
            color="#FEFAF6"
            fontFamily="var(--FedraSerifDisplay-Regular)"
          >
            {sectionContent?.title}{' '}
          </Text>
          {sectionContent?.subTitle && (
            <Box
              as="span"
              color="#FEFAF6"
              fontFamily="var(--FedraSerifDisplay-Bold)"
            >
              {sectionContent?.subTitle}
            </Box>
          )}
        </Text>

        {sectionContent?.link && (
          <Link
            fontFamily={'var(--FedraSansStd-medium)'}
            fontWeight="400"
            fontSize="1rem"
            lineHeight="1.6rem"
            color="#F1EDE9"
            _hover={{ textDecoration: 'none' }}
            href={refineUrlDomain(sectionContent?.link?.linkUrl, lang)}
            prefetch
          >
            {isMobile && sectionContent?.link?.buttonText}
            <Box as="span" marginLeft="0.5rem" color={'#FEFAF6'}>
              <ArrowForwardIcon
                boxSize="24px"
                display={{ base: 'none', md: 'inline-block' }}
              />
              <Center
                boxSize="48px"
                borderRadius="full"
                bg="#1A1D21"
                display={{ base: 'flex', md: 'none' }}
                // position="absolute"
                right={{ base: '1rem' }}
                top={{ base: '12%' }}
              >
                <ArrowForwardIcon boxSize="24px" color={'#F1EDE9'} />
              </Center>
            </Box>
          </Link>
        )}
      </Box>

      <Box
        bgGradient={bgColor}
        bgPosition="center"
        position="relative"
        mt={{ md: '10rem', lg: '0', '2xl': '3%' }}
        backgroundImage={{
          base: `${config.imgPath}/d/46272/1729177777-relatedpostbg.png`,
          lg: `${config.imgPath}/d/46272/1725096856-ps-related-bg.jpg`,
        }}
        bgSize={{ base: '100% 100%', lg: '100% 95%', xl: '100% 80%' }}
        w="100%"
        backgroundRepeat="no-repeat"
        height="100%"
      >
        <Flex
          flexDirection={{ base: 'column', lg: 'row' }}
          alignItems="center"
          pt={{ base: '5rem', md: '0' }}
          pb={{ base: '5rem', md: '0' }}
          mt={{ base: '20%', md: '0', lg: '6rem', xl: '2rem', '2xl': '0' }}
          maxWidth="100%"
          position="relative"
          height="100%"
          px={{ base: '16px', xl: '0' }}
          w="100%"
          mx="auto"
          maxW={{ base: 'none', sm: 500, lg: 1160, '2xl': 1470 }}
        >
          <Box
            width={{ base: '100%', lg: '50%' }}
            h="100%"
            mt={{ base: '-35%', lg: '0' }}
          >
            <Link
              href={refineUrlDomain(
                `blog/${sectionContent?.content[0]?.urlAlias}`
              )}
              _hover={{
                textDecoration: 'none',
              }}
              width="100%"
              height="100%"
              display="block"
              position="relative"
              prefetch
            >
              <LazyLoadImageComponent
                src={sectionContent?.content[0]?.heroImage?.url}
                alt={sectionContent?.content[0]?.heroImage?.alt}
                className="sadhguruImage"
                // borderRadius="md"
                width="100%"
                height="100%"
              />
            </Link>
          </Box>
          <Box
            width={{ base: '100%', md: '100%', lg: '40%' }}
            textAlign="left"
            mt={{
              base: '1rem',
              lg: '0',
              '2xl': '0rem',
            }}
            mb={{ base: '0', sm: '5rem', md: '5rem', lg: '2rem' }}
            ml={{ base: '0', lg: '2rem' }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap="0.625rem"
            >
              <Heading
                fontSize={{ base: '1.125rem', lg: '1.5rem' }}
                fontWeight="500"
                fontFamily="var(--FedraSansStd-medium)"
                lineHeight={{ base: '1.8rem', md: '28.8px', lg: '2.4rem' }}
                color="#FEFAF6"
                letterSpacing={'0.32px'}
                mb={{ base: 4, md: 2, xl: 2 }}
                as="h3"
              >
                <Link
                  href={refineUrlDomain(
                    `blog/${sectionContent?.content[0]?.urlAlias}`
                  )}
                  _hover={{
                    textDecoration: 'none',
                  }}
                  prefetch
                >
                  {sectionContent?.content[0]?.title}
                </Link>
              </Heading>
              {/* Share icon with click handler */}
              <Button
                variant="link"
                onClick={handleIconClick}
                mr={{ md: '-3rem', lg: '0', '2xl': '2rem' }}
                pos="relative"
              >
                <RiShareForwardLine color="#FEFAF6" fontSize={'1.5rem'} />
                <Box pos="absolute" top="100%" left="0">
                  {showIcons && (
                    <EmbedIcons flexDirection="column" iconColor="#FEFAF6" />
                  )}
                </Box>
              </Button>
              {/* Conditionally render EmbedIcons */}
            </Box>

            <Text
              mt={{ lg: '0.5rem' }}
              display="flex"
              alignItems="center"
              gap="0.5rem"
              fontWeight="400"
              fontFamily="var(--FedraSansStd-book)"
              fontSize="0.875rem"
              lineHeight="1.4rem"
              color="#FFFFFF"
            >
              <BiMicrophone fontSize="2rem" width="2.5rem" height="2.5rem" />
              {sectionContent?.content[0]?.types?.charAt(0).toUpperCase() +
                sectionContent?.content[0]?.types?.slice(1)}{' '}
              |{' '}
              {sectionContent?.content[0]?.category?.charAt(0).toUpperCase() +
                sectionContent?.content[0]?.category?.slice(1)}
            </Text>

            <Box mt={{ base: '1rem', lg: '1.5rem', '2xl': '2.5rem' }}>
              <Link
                href={refineUrlDomain(
                  `blog/${sectionContent?.content[0]?.urlAlias}`
                )}
                _hover={{
                  textDecoration: 'none',
                }}
                prefetch
              >
                <Text
                  color={textColor}
                  letterSpacing={'0.32px'}
                  fontFamily="var(--FedraSansStd-book)"
                  lineHeight={{ base: '1.2rem', md: '22.4px', lg: '1.6rem' }}
                  fontSize={{ base: '0.75rem', md: '14px', lg: '1rem' }}
                >
                  {sectionContent?.content[0]?.summary}
                </Text>
              </Link>
            </Box>
          </Box>
          <Box
            top={{ base: '0' }}
            display={{ base: 'none', lg: 'block' }}
            right={{ base: '0', lg: '-8%', xl: '6%', '2xl': '14%' }}
            maxWidth={{ base: '594px', md: '80%' }}
            marginBottom={{ '2xl': '5%' }}
            width={{ xl: '72px', '2xl': 'auto' }}
            height={{ xl: '275px' }}
          >
            <LazyLoadImageComponent
              src="https://static.sadhguru.org/d/46272/1736344844-kolam-blogpost.png"
              alt="Featured blog post image"
              borderRadius="md"
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default PsRelatedPost;
